import { createFileRoute } from "@tanstack/react-router";
import {
  IntersectionPage,
  buildIntersectionHead,
} from "@/components/IntersectionPage";
import { INTERSECTION_CONFIGS } from "@/lib/intersectionData";

const CONFIG = INTERSECTION_CONFIGS.find((c) => c.slug === "plumbing-seo-greenwood-village")!;

export const Route = createFileRoute("/plumbing-seo-greenwood-village")({
  head: () => buildIntersectionHead(CONFIG),
  component: () => <IntersectionPage config={CONFIG} />,
});
